import { Box } from '@chakra-ui/react';
import HelpComponent from '../components/Web/Help';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import ReactGA from 'react-ga4';
ReactGA.initialize('G-YMJYGJM7BD');

const CANONICAL_URL = 'https://www.routeforecast.app/help';
const OG_IMAGE = 'https://www.routeforecast.app/ogimage.jpg';

export default function Help() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language?.split('-')[0] || 'es';

  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: '/help' });
  }, []);

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name:
          lang === 'en'
            ? 'How do I plan a route with weather forecast?'
            : '¿Cómo planifico una ruta con pronóstico del tiempo?',
        acceptedAnswer: {
          '@type': 'Answer',
          text:
            lang === 'en'
              ? 'Go to the map page, enter your origin and destination, select your transport mode, and click Calculate Route. You will see the weather forecast at each point of your route.'
              : 'Accede al mapa, introduce origen y destino, selecciona el medio de transporte y pulsa Calcular Ruta. Verás el pronóstico del tiempo en cada punto de tu ruta.',
        },
      },
      {
        '@type': 'Question',
        name:
          lang === 'en'
            ? 'Does Route Forecast work for international routes?'
            : '¿Funciona Route Forecast para rutas internacionales?',
        acceptedAnswer: {
          '@type': 'Answer',
          text:
            lang === 'en'
              ? 'Yes. Route Forecast uses Google Weather API to provide accurate weather forecasts for any route worldwide, not just Spain.'
              : 'Sí. Route Forecast usa Google Weather API para ofrecer pronósticos precisos en cualquier punto del mundo, no solo en España.',
        },
      },
      {
        '@type': 'Question',
        name:
          lang === 'en'
            ? 'What transport modes are supported?'
            : '¿Qué medios de transporte están disponibles?',
        acceptedAnswer: {
          '@type': 'Answer',
          text:
            lang === 'en'
              ? 'Route Forecast supports car, bicycle, and walking modes.'
              : 'Route Forecast soporta los modos coche, bicicleta y a pie.',
        },
      },
      {
        '@type': 'Question',
        name:
          lang === 'en'
            ? 'Is Route Forecast free to use?'
            : '¿Es Route Forecast gratuito?',
        acceptedAnswer: {
          '@type': 'Answer',
          text:
            lang === 'en'
              ? 'Yes, Route Forecast is completely free to use.'
              : 'Sí, Route Forecast es completamente gratuito.',
        },
      },
    ],
  };

  return (
    <Box>
      <Helmet>
        <title>{t('seo.helpTitle')}</title>
        <meta name="description" content={t('seo.helpDesc')} />
        <link rel="canonical" href={CANONICAL_URL} />
        <link rel="alternate" hrefLang="es" href={`${CANONICAL_URL}?lang=es`} />
        <link rel="alternate" hrefLang="en" href={`${CANONICAL_URL}?lang=en`} />
        <link rel="alternate" hrefLang="x-default" href={CANONICAL_URL} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={CANONICAL_URL} />
        <meta property="og:title" content={t('seo.helpTitle')} />
        <meta property="og:description" content={t('seo.helpDesc')} />
        <meta property="og:image" content={OG_IMAGE} />
        <meta property="og:locale" content={lang === 'en' ? 'en_US' : 'es_ES'} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={t('seo.helpTitle')} />
        <meta name="twitter:description" content={t('seo.helpDesc')} />
        <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      </Helmet>
      <HelpComponent />
    </Box>
  );
}
